module.exports = __webpack_public_path__ + "img/hic-lung-cancer-male.ee88c0c6.png";